import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { authGuard } from './core/guards/auth-guard';
import { Layout } from './pages/sidebar/layout';
import { Inicio } from './pages/inicio/inicio';
import { Pacientes } from './pages/pacientes/pacientes';
import { Consultas } from './pages/consultas/consultas';
import { Estudios } from './pages/estudios/estudios';
import { Configuraciones } from './pages/configuraciones/configuraciones';
import { RecuperarPassword } from './pages/recuperar-password/recuperar-password';
import { RestablecerPassword } from './pages/restablecer-password/restablecer-password';
// import { Reportes } from './pages/reportes/reportes';
// import { Configuracion } from './pages/configuracion/configuracion';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: 'login',
    component: Login,
  },

  {
    path: '',
    component: Layout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'inicio',
        pathMatch: 'full',
      },

      {
        path: 'inicio',
        component: Inicio,
      },

      {
        path: 'pacientes',
        component: Pacientes,
      },

      {
        path: 'consultas',
        component: Consultas,
      },

      {
        path: 'estudios',
        component: Estudios,
      },

      {
        path: 'configuraciones',
        component: Configuraciones,
      },
    ],
  },

  {
    path: 'verificacion-email',
    loadComponent: () =>
      import('./pages/verificacion-email/verificacion-email').then((m) => m.VerificacionEmail),
  },

  {
    path: 'recuperar-password',
    component: RecuperarPassword,
  },
  {
    path: 'restablecer-password',
    component: RestablecerPassword,
  },

  {
    path: '**',
    redirectTo: 'login',
  },
];
